export default {
  addProject: {
    appUrl: 'Promotion Product Link',
    appUrlPlaceholder: "Please enter the product's app store link",
    invalidLinkFormat: 'Invalid URL format.',
    languages: 'Target Language',
    ratios: 'Image Size',
    submit: 'Create',
  },
  projectList: {
    table: {
      languages: 'Language',
      ratios: 'Dimension',
    },
  },
}
